// Where the visitor probably is, from nothing but their clock.
//
// No geolocation prompt and no IP lookup: longitude comes from the timezone
// offset (15° an hour, the reader's slice of the world, centred) and latitude
// from a coarse guess per IANA region. Good to a continent, which is all it is
// used for — opening the map over the reader's part of the world, and choosing a
// holiday nearby to suggest on the landing.
export function visitorLocation(): { lon: number; lat: number } {
  let lon = 10;
  let lat = 30;
  try {
    const offMin = new Date().getTimezoneOffset(); // minutes behind UTC (UTC+2 => -120)
    lon = (((-offMin / 4 + 180) % 360) + 360) % 360 - 180;
    const region = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').split('/')[0];
    const latByRegion: Record<string, number> = { Africa: 3, America: 22, Antarctica: -70, Asia: 28, Atlantic: 32, Australia: -28, Europe: 48, Indian: -8, Pacific: 0 };
    if (region in latByRegion) lat = latByRegion[region];
  } catch {
    /* keep the default */
  }
  return { lon, lat };
}
